var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4996 35.5192C7.87252 35.5192 0.0371094 27.6838 0.0371094 18.0567C0.0371094 8.42954 7.87252 0.594238 17.4996 0.594238C27.1268 0.594238 34.9621 8.42954 34.9621 18.0567C34.9621 27.6838 27.1268 35.5192 17.4996 35.5192ZM17.4996 2.4713C8.90586 2.4713 1.91422 9.46289 1.91422 18.0567C1.91422 26.6505 8.90586 33.6422 17.4996 33.6422C26.0934 33.6422 33.0851 26.6505 33.0851 18.0567C33.0851 9.46289 26.0934 2.4713 17.4996 2.4713Z",
    fill: "#EC681C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7608 18.1373V28.2573C14.7608 28.4042 14.8793 28.5228 15.0262 28.5228H18.7852C18.9321 28.5228 19.0506 28.4042 19.0506 28.2573V17.9713H21.7762C21.9136 17.9713 22.0274 17.867 22.0369 17.7296L22.2976 14.6295C22.3118 14.4778 22.1885 14.3452 22.0369 14.3452H19.0506V12.1457C19.0506 11.629 19.4677 11.2119 19.9844 11.2119H22.0842C22.2312 11.2119 22.3497 11.0934 22.3497 10.9465V7.84641C22.3497 7.69947 22.2312 7.58105 22.0842 7.58105H18.5339C16.453 7.58105 14.7656 9.26851 14.7656 11.3494V14.3357H12.8885C12.7416 14.3357 12.623 14.4541 12.623 14.6011V17.7011C12.623 17.848 12.7416 17.9666 12.8885 17.9666H14.7656V18.1325L14.7608 18.1373Z",
    fill: "#EC681C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6de84a88d1bec971903abce34a2a9db8.svg";
export { ForwardRef as ReactComponent };